var map = {
	"./level1.json": [
		482,
		482
	],
	"./level2.json": [
		787,
		787
	],
	"./level3.json": [
		144,
		144
	],
	"./level4.json": [
		329,
		329
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 296;
module.exports = webpackAsyncContext;